export enum CreatePropertyOptions {
  MIGRATE_ARI = "MIGRATE_ARI",
}

export interface CreatePropertyEntity {
  id: string;
  originPropertyTicker: string;
  targetPropertyTicker: string;
  options: CreatePropertyOptions[];
}

export interface CreatePropertyRequestDto {
  toDevel: boolean;
  originPropertyTicker: string;
  targetPropertyTicker: string;
  emails?: string[];
  options: {
    migrateAri: boolean;
  };
}
